module.exports = __webpack_public_path__ + "img/cp-diver-2.6c817c15.svg";